<template>
  <div class="mt-4 example-area">
    <template v-for="(example, index) in exampleList">
      <div
        class="example-box"
        @click.stop="getQuiz(example)"
        :key="'A' + index"
        v-if="index <= 1"
      >
        <aha-skeleton-loader
          :width="isModalContent ? '160px' : '147.5px'"
          :height="isModalContent ? '20px' : '17px'"
          v-if="!example"
        />
        <div v-else>
          <img
            class="inline-block mr-1"
            src="@/assets/images/icon/sparkles_2728.png"
            width="16"
          >
          <span class="example-box__text">{{ example }}</span>
        </div>
      </div>
      <div
        class="example-box"
        @click.stop="getQuiz(example)"
        :key="'B' + index"
        v-if="index > 1 && isExpandExampleList"
      >
        <aha-skeleton-loader
          :width="isModalContent ? '160px' : '147.5px'"
          :height="isModalContent ? '20px' : '17px'"
          v-if="!example"
        />
        <div v-else>
          <img
            class="inline-block mr-1"
            src="@/assets/images/icon/sparkles_2728.png"
            width="16"
          >
          <span class="example-box__text">{{ example }}</span>
        </div>
      </div>
      <div
        class="inline-block ml-1 mb-2 cursor-pointer rounded-md expand-arrow-box"
        @click.stop="expandExampleList()"
        :key="index"
        v-if="index === 1 && !isExpandExampleList"
      >
        <aha-icon
          name="arrow-no-tail-white"
          width="13"
          height="13"
          viewBox="0 0 16 16"
          class="expand-arrow-box__icon"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    isModalContent: {
      type: Boolean,
      default: false,
    },
    isExpandExampleList: {
      type: Boolean,
      default: false,
    },
    preventTracking: {
      type: Boolean,
      default: false,
    },
    customSamples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      allExamples: [],
      exampleList: [],
      gaSideLeftModalText: 'Create new slide modal',
    }
  },
  computed: {
    ...mapState({
      slideGenerator: (state) => state.slideGenerator,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  async mounted() {
    await this.setExampleList()
    if (this.customSamples.length) {
      this.exampleList = this.customSamples
      return
    }
    this.exampleList = OpenAIUtils.getRandomItemsInArray(this.allExamples, 4)
  },
  methods: {
    setExampleList() {
      const userCountry = this.currentUser.country ? this.currentUser.country : 'Singapore'
      const userFirstName = this.currentUser.firstName ? this.currentUser.firstName : 'Lily'
      const userCity = this.currentUser.city ? this.currentUser.city : 'Paris'
      const nextMonth = moment().add(1, 'months').format('MMMM')
      const economyUserCountry = this.currentUser.country ? this.currentUser.country : 'Germany'

      this.allExamples = [
        `fun facts about ${userCountry}`,
        `introducing ${userFirstName} to the team`,
        `places to visit in ${userCity}`,
        `memorable events in ${nextMonth}`,
        'funny icebreaker questions',
        `economy of ${economyUserCountry}`,
        'active listening',
        'how to be more inclusive',
        'mental health at work',
        'leadership skills training',
      ]
    },

    expandExampleList() {
      this.$emit('expandExampleList')
    },

    getQuiz(example) {
      this.$emit('handleGenerateSlides', 'Examples', example)
      if (this.preventTracking) return
      const eventAction = 'AI Quiz Generator > Example'
      const trackData = {
        eventAction,
        eventCategory: eventCategories.PRESENTATION_EDITOR,
        presentationId: this.presentation.id,
        exampleContent: example,
        userId: this.currentUser.id,
        touchPoint: this.slideGenerator.gaTouchPointWhenOpenAIModal ?
          this.slideGenerator.gaTouchPointWhenOpenAIModal : this.gaSideLeftModalText,
      }
      utils.trackGA4AndMixpanel(eventAction, trackData)
    },
  },
}
</script>

<style lang="scss" scoped>
.example-area {
  color: white;
  min-height: 40px;
  position: relative;
  z-index: 1;
  .example-box {
    @apply inline-block ml-1 mb-2 cursor-pointer rounded-md;
    background-color: rgba(0, 0, 0, 0.4);
    padding: 6px 8px;
    border-radius: 6px;
    font-size: 12px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
    &::v-deep {
      .skeleton-loader {
        border-radius: 6px;
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
  }
  .expand-arrow-box {
    background-color: rgba(0, 0, 0, 0.4);
    padding: 6px 12px;
    border-radius: 6px;
    position: relative;
    z-index: 1;
    font-size: 12px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.4);
    }

    .expand-arrow-box__icon {
      transform: rotate(180deg);
    }
  }
  @media (max-width: 798px) {
    @apply text-center;
  }
  @media (max-width: 500px) {
    margin-top: 20px !important;
  }
}
</style>
